import { styled } from '@mui/material/styles';

import PageMargins from '@/components/ui/PageMargins/PageMargins';

export const Wrapper = styled(PageMargins)(({ theme }) => ({
  marginBottom: theme.spacing(10),
}));
